/* LC — Masque le tab flottant "Avis" (Judge.me) quand le tiroir panier/recherche est ouvert */
(function(){
  'use strict';
  var avisTab = null;
  function findTab(){
    if (avisTab && document.contains(avisTab)) return avisTab;
    avisTab = document.querySelector('.jdgm-all-reviews-tab, [class*="all-reviews-tab"], [id*="all-reviews-tab"]');
    if (avisTab) return avisTab;
    // Fallback indépendant de la classe : élément fixe contenant "Avis"
    var nodes = document.querySelectorAll('a, div, button, span');
    for (var i = 0; i < nodes.length; i++){
      var el = nodes[i];
      var txt = (el.textContent || '').replace(/\s+/g, ' ').trim();
      if (txt && txt.length <= 16 && /avis/i.test(txt)){
        var cs = window.getComputedStyle(el);
        if (cs.position === 'fixed'){ avisTab = el; return el; }
      }
    }
    return null;
  }
  var drawers = [].slice.call(document.querySelectorAll('cart-drawer, search-drawer'));
  if (!drawers.length) return;
  function anyOpen(){ return drawers.some(function(d){ return !d.hasAttribute('hidden'); }); }
  function apply(){
    var el = findTab();
    if (!el) return;
    if (anyOpen()){
      el.dataset.lcHidden = '1';
      el.style.setProperty('opacity', '0', 'important');
      el.style.setProperty('visibility', 'hidden', 'important');
      el.style.setProperty('pointer-events', 'none', 'important');
      el.style.setProperty('transition', 'opacity .2s', 'important');
    } else if (el.dataset && el.dataset.lcHidden){
      el.style.removeProperty('opacity');
      el.style.removeProperty('visibility');
      el.style.removeProperty('pointer-events');
      delete el.dataset.lcHidden;
    }
  }
  if ('MutationObserver' in window){
    drawers.forEach(function(d){
      new MutationObserver(apply).observe(d, { attributes: true, attributeFilter: ['hidden'] });
    });
  }
})();
